import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getPhoneNumberPrivileges } from 'src/app/privileges/privileges.selector';
import { PhoneNumberPrivileges } from '../phone-number-details/models/phone-number-privileges';
import { PhoneNumbersFilterOption } from './models/phone-number-filter-option';
import { PhoneNumberOrderingOptions, PhoneNumberRegisterOptions } from './models/phone-number-register-options';
import { PhoneNumberRegisterListItem } from './models/phone-number-register-results.model';
import {
   createPhoneNumber,
   phoneNumberRegisterAdapterActions,
   phoneNumberRegisterInitialFilter,
} from './state/phone-number-register.actions';
import * as phoneNumberRegisterReducer from './state/phone-number-register.reducer';

@Directive()
export class PhoneNumberRegister
   extends Register<PhoneNumberRegisterListItem, PhoneNumberRegisterOptions, PhoneNumberOrderingOptions>
   implements OnInit
{
   columns: string[];

   filters: PhoneNumbersFilterOption[];

   entityName = 'Phone Number';

   phoneNumberPrivileges$: Observable<PhoneNumberPrivileges>;

   constructor(public store: Store) {
      super(store, phoneNumberRegisterReducer.selectors, phoneNumberRegisterAdapterActions);
      this.phoneNumberPrivileges$ = store.pipe(select(getPhoneNumberPrivileges));
   }

   ngOnInit() {
      this.store.dispatch(phoneNumberRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createPhoneNumber());
   }
}
